// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__-RhId","etoile":"Rating_etoile__aadYZ"};